/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
// Components
import CvuPanel from 'components/cvuPanel'
import Table from 'components/table'
import TableItem from 'components/TableItem'
import PageTitle from 'components/title'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'

import handleNotification from 'utils/toast/handleNotification'
import { ToastWayniLogo } from 'assets/icons'

// Context and Constant
import { tableItemButton } from 'constants/tableItem'
import { MeContext } from 'contexts/me'
import WORDING from 'constants/wording'

import useShare from '../../hooks/useShare'

export default function Cvu() {
  const [isLoading, setIsLoading] = useState()
  const { successToast } = handleNotification()
  const { me } = useContext(MeContext)
  const { handleShare, showButtonCopy, setShareData } = useShare()
  const { COPIADO, CVU, CVU_TITULO, ALIAS } = WORDING

  useEffect(() => {
    setIsLoading(true)
    if (me) {
      setShareData({
        title: 'Wayni',
        text: `Te comparto mis Wayni datos: Alias: ${texts.alias.value}, Cvu:  ${texts.cvu.value}`
      })
      setIsLoading(false)
    }
  }, [me])

  const texts = {
    cvu: { label: CVU, value: me?.bank?.internal_account[0].cvu },
    alias: { label: ALIAS, value: me?.bank?.internal_account[0].cvu_alias }
  }

  function onCopyAll() {
    navigator.clipboard
      .writeText(`Alias: ${texts.alias.value}, Cvu: ${texts.cvu.value}`)
      .then(() => {
        successToast(COPIADO)
      })
  }

  function onCopy() {
    navigator.clipboard.writeText(`${texts.cvu.value}`)
    successToast(COPIADO, <ToastWayniLogo />)
  }

  const handleView = () => {
    if (me) {
      return (
        <Table>
          <TableItem
            label={texts.cvu.label}
            value={texts.cvu.value}
            buttonType={tableItemButton.COPY}
            onClick={() => onCopy()}
          />
        </Table>
      )
    }
    return (
      <div className='flex items-center justify-center'>
        <Skeleton
          height='54px'
          containerClassName='block leading-none xs:w-full md:w-[564px]'
        />
      </div>
    )
  }

  return (
    <PageWrapper noTabBar title='Mi CVU'>
      <section className='flex flex-col h-[80vh] md:h-auto text-center text-black mx-auto sm:max-w-564'>
        <PageTitle subTitleText={CVU_TITULO} />
        <CvuPanel userName={me?.bank?.internal_account[0].cvu_alias} />
        {handleView()}

        <div className='flex mt-auto w-full md:mt-8 ml-0 sm:w-40 sm:ml-auto'>
          {isLoading ? (
            <Skeleton height={48} width={160} className='mt-3' />
          ) : (
            <>
              {!showButtonCopy ? (
                <PrimaryButton
                  type='button'
                  isDisabled={showButtonCopy}
                  buttonText='Compartir'
                  isShare
                  primaryButtonFunction={() => {
                    handleShare()
                  }}
                />
              ) : (
                <PrimaryButton
                  type='button'
                  buttonText='Copiar'
                  primaryButtonFunction={() => {
                    onCopyAll()
                  }}
                />
              )}
            </>
          )}
        </div>
      </section>
    </PageWrapper>
  )
}
